// State
export const state = () => ({
	loading: false,
	players: {},
	profiles: null
})

// Actions
export const actions = {
	// Get all
	async players({ commit }, params) {
		try {
			commit('loading', true)
			await this.$axios
				.get(`/affiliates/players`, { params })
				.then((response) => {
					commit('setPlayers', response.data)
					commit('loading', false)
				})
		} catch (error) {
			commit('loading', false)
		}
	},
	async cratePlayers({ commit }, form) {
		try {
			commit('loading', true)
			const response = await this.$axios
				.post(`/affiliates/players`, form)
				.then((response) => {
					commit('loading', false)
					return true
				})
			return response
		} catch (error) {
			commit('loading', false)
		}
	},
	async profiles({ commit }, params) {
		try {
			commit('loading', true)
			await this.$axios
				.get(`/affiliates/me/info`, { params })
				.then((response) => {
					commit('setProfile', response.data)
					commit('loading', false)
				})
		} catch (error) {
			commit('loading', false)
		}
	}
}

// Mutations
export const mutations = {
	loading(state, type) {
		state.loading = type
	},
	setPlayers(state, data) {
		state.players = data
	},
	setProfile(state, data) {
		state.profiles = data;
	}
}

// Getters
export const getters = {}
